package com.milta.core.localization.translations.pl

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Osiągnięto limit optymalizacji",
    exhaustedCreateRouteMessage = "Ponownie dostępne {date}. Możesz utworzyć trasę bez optymalizacji: wprowadzona kolejność zostanie zachowana.",
    exhaustedCreateBatchMessage = "Ponownie {limit} optymalizacji od {date}. Partię można utworzyć bez optymalizacji: wprowadzona kolejność zostanie zachowana.",
    quotaReachedResetOn = "Osiągnięto limit optymalizacji — reset {date}",
    routeCreatedInEnteredOrder = "Trasa utworzona we wprowadzonej kolejności.",
    routeWillBeCreatedInEnteredOrder = "Trasa zostanie utworzona we wprowadzonej kolejności.",
    batchCreatedInEnteredOrder = "Partia została utworzona bez optymalizacji, we wprowadzonej kolejności.",
    sendWithoutOptimization = "Wyślij bez optymalizacji",
    batchNotOptimizedTitle = "Partia utworzona bez optymalizacji",
    batchNotOptimizedMessage = "Osiągnięto limit optymalizacji. Obecna kolejność przystanków zostaje zachowana.",
    batchNotOptimizedMobileMessage = "Partia utworzona bez optymalizacji: osiągnięto limit optymalizacji. Wprowadzona kolejność zachowana, przystanki podzielone równo.",
    reoptimizeAction = "Optymalizuj ponownie",
    reoptimizeUnavailableWeb = "Ponowna optymalizacja niedostępna: osiągnięto limit, ponownie {date}. Obecna kolejność zostaje zachowana, a wysyłka jest nadal możliwa.",
    reoptimizeUnavailableMobile = "Ponowna optymalizacja niedostępna do {date} (osiągnięto limit). Wysyłka jest nadal możliwa.",
    stopAddedAtEndTitle = "Przystanek dodany na końcu trasy",
    stopAddedAtEndMessage = "Osiągnięto limit optymalizacji — reset {date}. Kolejność pozostałych przystanków się nie zmienia.",
    reoptimizeExhaustedHint = "Osiągnięto limit optymalizacji, ponownie {date}",
    myOptimizationsTitle = "Moje optymalizacje",
    remainingForPeriod = "Pozostało w tym okresie",
    remainingSuffix = "pozostało",
    resetLabel = "Reset",
    resetAtRenewal = "Przy odnowieniu subskrypcji",
    driverExplanation = "Resetuje się przy odnowieniu subskrypcji. Kierowca Firmy: Twój licznik podąża za subskrypcją Firmy, z limitem próbnym, dopóki jest w okresie próbnym.",
    enterpriseExplanation = "Resetuje się przy odnowieniu subskrypcji. Ten licznik dotyczy tylko Twoich optymalizacji; każdy kierowca ma własny.",
    webCounterNotice = "Ten licznik dotyczy tylko optymalizacji uruchomionych przez to konto. Każdy kierowca ma własny, widoczny w swojej aplikacji.",
    historyTitle = "Historia",
    columnDate = "Data",
    columnAction = "Akcja",
    columnTarget = "Dotyczy trasy",
    columnOutcome = "Wynik",
    actionOptimizeRoute = "Optymalizacja trasy",
    actionCreateRouteBatch = "Utworzenie partii",
    actionReoptimizeRouteBatch = "Ponowna optymalizacja partii",
    actionReoptimizeOnStopAdded = "Ponowna optymalizacja po dodaniu przystanku",
    actionReoptimizeInPlace = "Ponowna optymalizacja w trasie",
    actionCreateOwnRoute = "Utworzenie mojej trasy",
    outcomeCounted = "Policzona",
    outcomeRefunded = "Zwrócona",
    outcomeRefundedLong = "Zwrócona — błąd RoutaR",
    refundedNotCounted = "błąd RoutaR, niepoliczona",
    targetRoute = "Trasa z {date}",
    targetBatch = "Partia z {date}",
    historyLoadingMore = "Ładowanie kolejnych wierszy…",
    historyEnd = "Koniec historii — {count} wierszy",
    historyEmpty = "Brak optymalizacji w tym okresie.",
    historyLoadError = "Nie udało się wczytać historii.",
    retryAction = "Spróbuj ponownie",
    loading = "Ładowanie…",
    errorNoConnection = "Nie można połączyć się z serwerem — sprawdź połączenie.",
    errorGeneric = "Wystąpił błąd. Spróbuj ponownie później.",
    tabOptimizations = "Optymalizacje RoutaR",
    tabAiTokens = "Tokeny AI",
    comingSoon = "Wkrótce",
    limitsDescription = "Liczba dozwolonych optymalizacji RoutaR na konto i okres subskrypcji, zależnie od typu konta i statusu subskrypcji. Licznik każdego konta resetuje się przy odnowieniu jego subskrypcji.",
    columnTrial = "Próbny",
    columnPaid = "Płatny",
    rowEnterprise = "Konto Firmy",
    rowDriver = "Kierowca",
    fieldRequired = "Pole obowiązkowe.",
    fieldMustBePositive = "Musi być większe od 0.",
    limitsFootnote = "Wartości w optymalizacjach na okres. Kierowca Firmy otrzymuje limit „Kierowca”, próbny dopóki jego Firma jest w okresie próbnym, w przeciwnym razie płatny.",
    limitsSaved = "Limity zapisane. Firma: {enterpriseTrial} próbny · {enterprisePaid} płatny. Kierowca: {driverTrial} próbny · {driverPaid} płatny.",
    limitsRejected = "Wartości odrzucone: każdy limit musi być większy od 0.",
    saveAction = "Zapisz",
    detailsAction = "Szczegóły",
    accountDetailsTitle = "Szczegóły użytkownika",
    sectionIdentity = "Tożsamość",
    accountTypeLabel = "Typ konta",
    kindEnterpriseOwner = "Konto Firmy",
    kindEnterpriseDriver = "Kierowca Firmy",
    kindIndependentDriver = "Niezależny kierowca",
    withoutOrganisation = "Bez organizacji",
    subscriptionLabel = "Subskrypcja",
    viaOrganisation = "Przez organizację",
    subscriptionTrial = "Próbny",
    subscriptionPaid = "Płatny",
    appliedLimitLabel = "Zastosowany limit",
    limitKindEnterprise = "Limit Konta Firmy",
    limitKindDriver = "Limit Kierowcy",
    enterpriseInTrialSuffix = "(Firma jest w okresie próbnym)",
    resetSourceOwn = "Odnowienie subskrypcji",
    resetSourceEnterprise = "Odnowienie {enterprise}",
    exhaustedBadge = "Limit wyczerpany",
    manuallyAdjustedBadge = "Zastąpiono ręcznie",
    replaceLabel = "Zastąp pozostałą liczbę",
    replaceAction = "Zastąp",
    replaceHelp = "Tylko dla bieżącego okresu. Przy resecie konto zaczyna ponownie od limitu globalnego.",
    replaceHelpEnterpriseDriver = "Zmienia tylko licznik {name}. Licznik Firmy i innych kierowców się nie zmienia.",
    replaceInvalid = "Wpisz liczbę większą lub równą 0.",
    replaceRejected = "Wartość odrzucona przez serwer.",
    replaceMaximum = "Maksymalnie 100 000.",
    replacedBanner = "Pozostała liczba zastąpiona: {from} → {to}. Na bieżący okres. {date} powrót do limitu globalnego ({limit}).",
    adminHistoryTitle = "Historia optymalizacji",
    accountNotFound = "Nie znaleziono konta.",
)
